import { Box, ButtonNew } from '@jfs/ui-new'
import TabBar, { TabbarType } from '../../comps/Tabbar'
import { staticStrings } from '../../data/static/strings'
import { Routes } from '../../nav/routes'

interface TabBarHeaderProps {
  selectedTab: number
  setSelectedTab: any
  onAddNewWebhookPress: any
  navigation: any
  isUserManagementTabEnabled: boolean
  isLoading?: boolean
  highlightedTabString?: string | undefined
  canCreateNewUser?: boolean | undefined
  isAPICredentialsTabVisible?: boolean | undefined
  canViewWebHooks?: boolean | undefined
  canAddWebhooks?: boolean | undefined
}

export const tabTitles = (
  isUserManagementTabEnabled: boolean,
  isAPICredentialsTabVisible?: boolean | undefined,
  canViewWebHooks?: boolean | undefined,
) => {
  const dataObject = isAPICredentialsTabVisible ? [{ title: staticStrings.apiCredentials }] : []
  if (canViewWebHooks) {
    dataObject.push({ title: staticStrings.Webhooks })
  }
  if (isUserManagementTabEnabled) {
    dataObject.push({ title: staticStrings.userManagement })
  }
  return dataObject
}

const showButton = (
  index: number,
  onAddNewWebhookPress: () => void,
  navigation: any,
  highlightedTabString: string | undefined,
  canCreateNewUser: boolean | undefined,
  canAddWebhooks: boolean | undefined,
) => {
  if (index === 1 && highlightedTabString === staticStrings.Webhooks && canAddWebhooks) {
    return {
      showBtn: true,
      buttonText: '+ Add new webhook',
      onPress: () => onAddNewWebhookPress(),
    }
  } else if (highlightedTabString === staticStrings.userManagement && canCreateNewUser) {
    return {
      showBtn: true,
      buttonText: '+ Add New User',
      onPress: () => navigation?.navigate(Routes.USER_MANAGEMENT.ADD_NEW_USER),
    }
  }
  return {
    showBtn: false,
    buttonText: '',
    onPress: () => null,
  }
}

const TabBarHeader = ({
  selectedTab,
  setSelectedTab,
  onAddNewWebhookPress,
  navigation,
  isUserManagementTabEnabled,
  highlightedTabString,
  canCreateNewUser,
  isAPICredentialsTabVisible,
  canViewWebHooks = false,
  canAddWebhooks = false,
}: TabBarHeaderProps) => {
  const buttonRules = showButton(
    selectedTab,
    onAddNewWebhookPress,
    navigation,
    highlightedTabString,
    canCreateNewUser,
    canAddWebhooks,
  )
  return (
    <Box flexDirection={'row'}>
      <Box marginRight="auto" height={32}>
        <TabBar
          titles={tabTitles(isUserManagementTabEnabled, isAPICredentialsTabVisible, canViewWebHooks)}
          default={selectedTab}
          onSelected={(index: any, titleText: string | undefined) => {
            setSelectedTab(index, titleText)
          }}
          type={TabbarType.recentPayments}
        />
      </Box>
      <ButtonNew
        hide={!buttonRules.showBtn}
        type="primarySmall"
        title={buttonRules.buttonText}
        borderRadius={4}
        onPress={() => buttonRules.onPress()}
      />
    </Box>
  )
}

export { TabBarHeader }
